<script setup>
const isConfirmationModalOpen = useState('isConfirmationModalOpen', () => false);
const confirmationModalProps = useState('confirmationModalProps', () => {
  return {
    title: '',
    description: '',
    actionLabel: '',
    actionColor: 'primary',
    hideCancel: false,
    onAction: () => {},
    middleButtonLabel: '',
    middleButtonAction: () => {},
  };
});

const loading = ref(false);
const buttonAction = async () => {
  loading.value = true;
  await confirmationModalProps.value.onAction();
  loading.value = false;
};

const hasMiddleButton = computed(() => {
  return (
    confirmationModalProps.value.middleButtonLabel &&
    confirmationModalProps.value.middleButtonAction
  );
});

// Only show when explicitly opened and we have content (avoids showing on load or empty modal)
const shouldShowModal = computed(
  () => isConfirmationModalOpen.value && !!confirmationModalProps.value?.title
);
</script>

<template>
  <UModal
    v-if="shouldShowModal"
    v-model:open="isConfirmationModalOpen"
    :portal="true"
    :title="confirmationModalProps.title"
    :description="confirmationModalProps.description"
    :dismissible="false"
    :ui="{
      header: 'pb-0',
      description: 'mt-4 mb-2 text-gray-500 dark:text-gray-400 text-sm',
    }"
  >
    <template #footer>
      <UButton
        :color="confirmationModalProps.actionColor"
        :label="confirmationModalProps.actionLabel"
        :loading="loading"
        @click="buttonAction"
      />
      <UButton
        v-if="hasMiddleButton"
        :label="confirmationModalProps.middleButtonLabel"
        variant="soft"
        class="ml-2"
        @click="confirmationModalProps.middleButtonAction"
      />
      <UButton
        v-if="!confirmationModalProps.hideCancel"
        variant="soft"
        :color="hasMiddleButton ? 'neutral' : undefined"
        label="Cancel"
        class="ml-2"
        @click="isConfirmationModalOpen = false"
      />
    </template>
  </UModal>
</template>
